import React from "react";
import { observer } from "mobx-react";
import IconButton from '../../comum/components/IconButton'
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { formatarDataCustomHTML } from "../../../utils/formatar";
import { sortCaret } from "../../comum/components/Icones";

export default class ExportarExcelSolicitacoes extends React.Component {
    constructor(props) {
        super(props);
        
        this.timeRegExp = new RegExp("([0-9]{4}\-[0-9]{2}\-[0-9]{2}T[0-9]{2}\:[0-9]{2}:[0-9]{2})")
    }

    _exporter;
    export = () => {
        this._exporter.save();
    };

    render() {
        let lista = this.props.data || [];
        const hasFiles = lista.length <= 0;

        // if(lista.length > 0){
        //     lista.map(data => {
        //         const keys = Object.keys(data)
        //         keys.map(key =>{
        //             if(this.timeRegExp.test(data[key]) && moment(data[key]).format("DD/MM/YYYY HH:mm") !== 'Invalid date'){
        //                 data[key] = moment(data[key]).format("DD/MM/YYYY HH:mm")
        //             }
        //         })
        //     })
        // }

        let cols = [{
            dataField: 'ContId',
            text: 'Id',
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left',
        }, {
            dataField: 'Documento',
            text: 'BL (Master)',
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left',
        }, {
            dataField: 'Container',
            text: 'Container',
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left',
        }, {
            dataField: 'Operacao',
            text: 'Operação',
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            headerAlign: (column, colIndex) => 'left',
        }, {
            dataField: 'Solicitante',
            text: 'Solicitante',
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            headerAlign: (column, colIndex) => 'left',
        }, {
            dataField: 'DataCriacao',
            text: 'Data',
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            headerAlign: (column, colIndex) => 'left',
        }, {
            dataField: 'FlagStatus',
            text: 'Situacao',
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            headerAlign: (column, colIndex) => 'left',
        }];
    ;
        return (
            <div>
                <IconButton 
                    icon="file-excel" 
                    text="Baixar XLS" 
                    size="md" 
                    disabled={hasFiles} 
                    onClick={this.export} 
                />
                <ExcelExport
                    data={lista}
                    fileName="AcompanhamentoDeSolicitacoes.xlsx"
                    ref={(exporter) => { this._exporter = exporter; }} >
                    { cols.map((coluna, x) => (
                        <ExcelExportColumn
                            key={x}
                            title={coluna.text}
                            field={coluna.dataField}
                        />
                    )) }
                </ExcelExport>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/desova-pier/components/ExportarExcelSolicitacoes.js